import * as React from 'react'
import { CTAPrimary } from './shared/buttons'
import { openSubscribe } from '../actions/navigationActions'
import type { AppStateType } from '../reducers/appstate'
import type { Dispatch } from 'redux'
import { withRouter } from 'next/router'
import { connect, useSelector } from 'react-redux'

type PropsType = {
  ctaText?: string,
  styles?: string,
  id?: string
}

type DispatchPropsType = {
  openSubscribe: () => any
}

function SubscribeCta (props: PropsType & DispatchPropsType): React.ReactNode {
  const subscriptionCta = useSelector((state: AppStateType): string => state.subscriptionCTA)
  return (
    <CTAPrimary
      onClick={(): void => props.openSubscribe()}
      minWidth={232}
      styles={props.styles}
      id={props.id}
      className='subscribe-cta'
    >
      {props.ctaText || subscriptionCta}
    </CTAPrimary>
  )
}

const mapStateToProps = (state: AppStateType): { isSubscribed: any, signedIn: any } => {
  return {
    isSubscribed: state.user.isSubscribed,
    signedIn: state.user.id
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    openSubscribe: (): void => dispatch(openSubscribe())
  } as DispatchPropsType
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubscribeCta) as any) as any
